'use client'

import React, { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    OBR?: any
  }
}

export type OutbrainAdSlotProps = {
  id: string
}

export const OutbrainAdSlot: React.FC<OutbrainAdSlotProps> = ({ id }) => {
  const [source, setSource] = useState<string | undefined>()
  const OUTBRAIN_TEMPLATE = 'DE_WETTER.de'
  const pathName = usePathname()

  useEffect(() => {
    setSource(`https://www.wetter.de${pathName}`)
    if (window?.OBR) {
      window.OBR.extern.researchWidget()
    }
  }, [])

  return (
    <div data-ada-container={id} data-ob-identifier={`ad-outbrain-${id}`}>
      {source && (
        <div
          data-cy={`outbrain-ad-slot_${id}`}
          className="OUTBRAIN"
          data-src={source}
          data-widget-id={id}
          data-ob-template={OUTBRAIN_TEMPLATE}
        />
      )}
    </div>
  )
}
